import { GroupBase, StylesConfig } from "react-select";

/**
 * react-select styles that match the admin library inputs (.inp).
 * Used where a searchable select is needed (many mosques/locations).
 */
export function adminSelectStyles<
  Option,
  IsMulti extends boolean = false,
>(): StylesConfig<Option, IsMulti, GroupBase<Option>> {
  return {
    control: (base, state) => ({
      ...base,
      minHeight: 42,
      borderRadius: 12,
      borderColor: state.isFocused ? "#1D7A52" : "#D5DED9",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(29, 122, 82, 0.15)" : "none",
      background: state.isDisabled ? "#F4F7F5" : "#FFFFFF",
      fontSize: 14,
      "&:hover": { borderColor: state.isFocused ? "#1D7A52" : "#C3CFC9" },
    }),
    valueContainer: (base) => ({ ...base, padding: "0 12px" }),
    placeholder: (base) => ({ ...base, color: "#8A9C96" }),
    singleValue: (base) => ({ ...base, color: "#0D2A33" }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base) => ({ ...base, color: "#546A71" }),
    clearIndicator: (base) => ({ ...base, color: "#8A9C96" }),
    menuPortal: (base) => ({ ...base, zIndex: 1300 }),
    menu: (base) => ({
      ...base,
      borderRadius: 12,
      overflow: "hidden",
      fontSize: 14,
      color: "#0D2A33",
      border: "1px solid #E2E9E5",
      boxShadow: "0 16px 40px rgba(6, 37, 47, 0.18)",
    }),
    option: (base, state) => ({
      ...base,
      background: state.isSelected
        ? "#0B3B4C"
        : state.isFocused
          ? "#F1FAF5"
          : "#FFFFFF",
      color: state.isSelected ? "#FFFFFF" : "#0D2A33",
    }),
    multiValue: (base) => ({
      ...base,
      background: "#E1F4EA",
      borderRadius: 8,
    }),
    multiValueLabel: (base) => ({ ...base, color: "#145C3D", fontWeight: 700 }),
  };
}
